import React from "react";

import { LoadingIcon } from "@packages/ds";
import { Command } from "cmdk";
import { useIntl } from "react-intl";

import { selectCommandMenuDocsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import { useCommandMenuContext, useCommandResources } from "../hooks";
import * as S from "../styles";

import { DocsList } from "./DoctList";
import { Highlighter } from "./Highlighter";
import { Item } from "./Item";

type ResourcesListProps = {
  setSelectedResource: React.Dispatch<
    React.SetStateAction<
      | {
          type: "projects" | "organizations";
          id: string;
          name: string;
        }
      | undefined
    >
  >;
};

export function ResourcesList({ setSelectedResource }: ResourcesListProps) {
  const { data, isLoading } = useCommandResources();
  const { inputValue } = useCommandMenuContext();
  const intl = useIntl();
  const dataEntries = React.useMemo(() => Object.entries(data), [data]);
  const isCommandMenuDocsEnabled = useAppSelector(selectCommandMenuDocsEnabled);

  return (
    <div>
      {isLoading ? (
        <S.LoaderContainer>
          <Command.Loading>
            <LoadingIcon />
          </Command.Loading>
        </S.LoaderContainer>
      ) : (
        <Command.Empty>
          {intl.formatMessage({ id: "command_k.no_results" })}
        </Command.Empty>
      )}
      {data &&
        dataEntries.map(([key, value]) => {
          return (
            <Command.Group
              heading={key.charAt(0).toUpperCase() + key.slice(1)}
              key={key}
            >
              {(Array.isArray(value) ? value : Object.values(value ?? {})).map(
                (resource: any, index) => {
                  return (
                    <Item
                      type="resource"
                      key={resource.id + index}
                      value={key + resource.name}
                      keywords={[resource.name]}
                      data-pendo-identifier={"result.type." + key}
                      onSelect={() =>
                        setSelectedResource({
                          type: key as "organizations" | "projects",
                          id: resource.id,
                          name: resource.name || resource.id
                        })
                      }
                    >
                      <Highlighter
                        searchText={inputValue}
                        textToHighlight={resource.name}
                      />
                    </Item>
                  );
                }
              )}
            </Command.Group>
          );
        })}
      {isCommandMenuDocsEnabled && <DocsList />}
    </div>
  );
}
